import { dateFormatter, useTranslation, parseDoorData } from '@fareye/common'
import { Flex, Span } from '@fareye/ui'
import {
  capitalize,
  isEmpty,
  MdBatteryUnknown,
  MdBatteryFull,
  MdBatteryAlert,
  MdSignalCellularOff,
  MdSignalCellularConnectedNoInternet4Bar,
  MdSignalCellular4Bar,
  toTileCase,
  subDays,
  Door
} from '@fareye/utils'
import React from 'react'
import Temperature from './Temperature'
const stringtoReactIconName = (name: string) =>
  name
    .split('-')
    .map(item => capitalize(item))
    .join('')

export default function DeviceDetails({
  id,
  deviceInfo,
  temperatureRange,
  timestamp,
  trackingProvider,
  actStartTime,
  t
}: any) {
  const Fa: any = {
    FaBatteryEmpty: {
      batterySymbol: MdBatteryUnknown,
      color: '#ADADAD'
    },
    FaBatteryFull: {
      batterySymbol: MdBatteryFull,
      color: '#279B4E'
    },
    FaBatteryQuarter: {
      batterySymbol: MdBatteryAlert,
      color: '#C84031'
    },
    FaBatteryThreeQuarters: {
      batterySymbol: MdBatteryFull,
      color: '#FDC500'
    }
  }

  const MdSignal: any = {
    '#f3f': {
      signalSymbol: MdSignalCellularOff,
      color: '#C84031'
    },
    yellow: {
      signalSymbol: MdSignalCellularConnectedNoInternet4Bar,
      color: '#FDC500'
    },
    cyan: {
      signalSymbol: MdSignalCellular4Bar,
      color: '#279B4E'
    },
    default: {
      signalSymbol: MdSignalCellularOff,
      color: '#ADADAD'
    }
  }
  const showFirstWord = (name = '') => name.split(' ')[0]
  const Icon =
    !!deviceInfo?.batteryStrength?.icon &&
    Fa[stringtoReactIconName(deviceInfo?.batteryStrength?.icon)].batterySymbol
  const signalIcon =
    deviceInfo?.signalStrength &&
    deviceInfo?.signalStrength?.color &&
    MdSignal[deviceInfo?.signalStrength?.color]
      ? MdSignal[deviceInfo?.signalStrength?.color]
      : MdSignal['default']
  const SignalIcon = !isEmpty(deviceInfo) && signalIcon.signalSymbol
  const doorsData = parseDoorData(deviceInfo?.extraData?.sensorData)
  return (
    <Flex column alignItemsFlexEnd>
      {!isEmpty(deviceInfo) ? (
        <Flex alignItemsCenter style={{ marginBottom: '1px' }}>
          {/* For Journey model we do not have percentage, so changing the logic as of now */}
          {!isEmpty(deviceInfo?.batteryPercentage) && (
            <Flex
              style={{ marginRight: '4px' }}
              title={deviceInfo?.batteryStrength?.value}
            >
              <Icon
                style={{
                  // transform: 'rotate(-90deg)'
                  position: 'relative'
                }}
                color={
                  Fa[stringtoReactIconName(deviceInfo?.batteryStrength?.icon)]
                    .color
                }
                size={14}
              />
              <Span>{showFirstWord(deviceInfo?.batteryStrength?.value)}</Span>
            </Flex>
          )}
          {!isEmpty(deviceInfo?.signalStrength) && (
            <Span>
              <SignalIcon
                style={{
                  color: signalIcon.color,
                  position: 'relative',
                  bottom: '-3px'
                }}
                title={deviceInfo?.signalStrength?.value}
                size={14}
              />
              <Span style={{ fontSize: '10px' }} ml={2}>
                {showFirstWord(deviceInfo?.signalStrength?.value)}
              </Span>
            </Span>
          )}
          <Temperature
            data={{ ...deviceInfo?.extraData, ...temperatureRange }}
            id={id}
          />
        </Flex>
      ) : ''}
      <Flex
        style={{
          paddingTop: '2px',
          marginBottom: '1px',
          fontSize: '12px'
        }}
      >
        {trackingProvider && (
          <Span
            style={{
              fontSize: '12px',
              lineHeight: '18px',
              marginLeft: '8px'
            }}
          >
            {t(toTileCase(trackingProvider))}
          </Span>
        )}
        {doorsData && (
          <Flex>
            <img style={{ padding: '0 4px', height: '14px' }} src={Door} />
            <Span>{doorsData}</Span>
          </Flex>
        )}
      </Flex>
      {(timestamp || actStartTime) && (
        <Span>{displayLastUpdatedAt(timestamp, actStartTime, t)}</Span>
      )}
    </Flex>
  )
}
function DeviceUnkown(props: any) {
  const { t } = useTranslation()
  return (
    <Flex alignItemsCenter>
      <Span mr={4} ml={-1} title={'Unknown'}>
        <MdBatteryUnknown
          style={{
            position: 'relative',
            bottom: '-3px'
          }}
          color="#ADADAD"
          size={14}
        />
        <Span style={{ fontSize: '10px' }}>{t('Unknown')}</Span>
      </Span>
      <Span>
        <MdSignalCellularOff
          style={{
            color: '#ADADAD',
            position: 'relative',
            bottom: '-3px'
          }}
          title={'Unknown'}
          size={14}
        />
        <Span style={{ fontSize: '10px' }} ml={2}>
          {t('Unknown')}
        </Span>
      </Span>
    </Flex>
  )
}

const displayLastUpdatedAt = (timestamp: any, actualTime: any, t: any) => {
  const timestampHideFlag = timestamp
    ? new Date(timestamp) > subDays(new Date(actualTime?.time), 1)
      ? dateFormatter(timestamp, 'ddMMMhhmmA')
      : '\u00a0'
    : '\u00a0'
  return (
    <Span
      title={timestamp ? dateFormatter(timestamp) || '' : ''}
      variant="secondary"
      style={{ fontSize: '12px', lineHeight: '18px' }}
    >
      {timestampHideFlag}
    </Span>
  )
}
